import { useEffect } from 'react';
import axios from 'axios';

// Share one in-flight permissions read between all instances of useAuth.
let pending = null;
const EVENT = 'logyra-user-updated';
export const publishUser = user => {
  localStorage.setItem('user', JSON.stringify(user));
  window.dispatchEvent(new CustomEvent(EVENT, { detail: user }));
};

export const useGestionnairePermissions = (user, setUser) => {
  useEffect(() => {
    const synchronize = event => {
      const next = event.detail;
      setUser(previous => previous?.id === next?.id && JSON.stringify(previous) !== JSON.stringify(next) ? next : previous);
    };
    window.addEventListener(EVENT, synchronize);
    return () => window.removeEventListener(EVENT, synchronize);
  }, [setUser]);

  useEffect(() => {
    if (!user?.is_gestionnaire) return;
    const refresh = async () => {
      const token = localStorage.getItem('token');
      if (!token || document.hidden) return;
      if (!pending) {
        pending = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/gestionnaires/me`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then(({ data }) => {
          const current = JSON.parse(localStorage.getItem('user') || 'null');
          if (current?.id !== data.id) return;
          const next = { ...current, allowed_tabs: data.allowed_tabs };
          if (JSON.stringify(current.allowed_tabs) !== JSON.stringify(next.allowed_tabs)) publishUser(next);
        }).catch(() => {}).finally(() => { pending = null; });
      }
      await pending;
    };
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [user?.id, user?.is_gestionnaire]);
};